import type { FC, Ref } from 'react';

import PasswordFormItemImpl from './PasswordFormItem';

export interface PasswordFormItemProps {
  [key: string]: any;
  refs?: Ref<any>;
  onPasswordChange?: (event: any) => void;
  size?: string;
  placeholder?: string;
  name?: string;
  value?: any;
  error?: boolean;
  errorMessage?: string;
  label?: string;
  formItemVariant?: string;
  autoComplete?: string;
}

const PasswordFormItem = PasswordFormItemImpl as unknown as FC<PasswordFormItemProps>;

export default PasswordFormItem;
